import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import {useTranslation} from "react-i18next";

// @ts-ignore
const ConfirmAction = ({triggerText, clickHandler, classNames}) => {
    const {t} = useTranslation();

    return (
        <AlertDialog>
            <AlertDialogTrigger className={classNames}>{triggerText}</AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{t("common.areYouSure")}</AlertDialogTitle>
                    <AlertDialogDescription>
                        {t("common.cannotBeUndone")}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>{t("common.cancel")}</AlertDialogCancel>
                    <AlertDialogAction
                        onClick={clickHandler}
                        className="bg-destructive/90 hover:bg-destructive">{t("common.continue")}</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}

export { ConfirmAction };
